import { Canvas } from "@react-three/fiber"
import { Environment, Html, OrbitControls, PerspectiveCamera } from "@react-three/drei"
import { Suspense, useEffect, useState } from "react"
import ProductModel from "./ProductModel"
import PresentationCamera from "./PresentationCamera"
import { useCounterStore } from "./stores/CounterStore"
import { RoomBaked } from "./RoomBaked"
import Loader from "./Loader"
import AdminInterface from "./ui/AdminInterface"
import { createClient } from "@supabase/supabase-js"

export default function AdminApp() {
    const assignCamId = useCounterStore((state) => state.assign)
    const camId = useCounterStore((state) => state.camTransformId)

    // const spots = [
    //     {label: "hex_1", position: [-2.865, 2.11, -.2], modelId: "", id: "hex_1"},
    //     {label: "hex_2", position: [-2.865, 1.69, -.215], modelId: "tbc100", id: "hex_2"}, // [-2.62, 1.78, -.28]
    //     {label: "hex_3", position: [-2.865, 1.85, -.67], modelId: "tbc100", id: "hex_3"},
    //     {label: "hex_4", position: [-2.865, 1.45, -.71], modelId: "tbc100", id: "hex_4"},
    //     {label: "hex_5", position: [-2.865, 2.11, -1.07], modelId: "tbc100", id: "hex_5"},
    //     {label: "hex_6", position: [-2.865, 1.61, -1.12], modelId: "tbc100", id: "hex_6"},
    //     {label: "hex_7", position: [-2.865, 1.85, -1.56], modelId: "tbc100", id: "hex_7"},
    //     {label: "hex_8", position: [-2.865, 1.32, -1.6], modelId: "tbc100", id: "hex_8"},
    //     {label: "hex_9", position: [-2.865, 2.325, -3.42], modelId: "tbc100", id: "hex_9"},
    //     {label: "hex_10", position: [-2.865, 2.6, -3.88], modelId: "tbc100", id: "hex_10"},
    //     {label: "hex_11", position: [-2.865, 2.06, -3.86], modelId: "tbc100", id: "hex_11"},
    //     {label: "hex_12", position: [-2.865, 2.34, -4.33], modelId: "tbc100", id: "hex_12"}
    // ]

    const supabase = createClient('https://ywdvmyrishxdrpupzvfj.supabase.co', 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inl3ZHZteXJpc2h4ZHJwdXB6dmZqIiwicm9sZSI6ImFub24iLCJpYXQiOjE2NzcxMzQ2ODgsImV4cCI6MTk5MjcxMDY4OH0.9_3HmDf07QhUQFWihZcXAMYYU137k0PU5Kn3s5ZVFr8')

    const [spots, setSpots] = useState([]);
    const [currentSpot, setCurrentSpot] = useState();

    const [currentMaterialSettings, setCurrentMaterialSettings] = useState({
        transmission: 1,
        opacity: 1,
        metalness: 0,
        roughness: 0,
        ior: 1.5,
        thickness: 0.01,
        specularIntensity: 1
    })

    const getMaterialSettings = (_matSettings) => {
        if (_matSettings == undefined) return {}
        if (_matSettings.transmission != undefined) return _matSettings
        return JSON.parse(_matSettings)
    }

    useEffect(() => {
        async function fetchSpots() {
            const _spots = await supabase.from('spots').select('*')
            setSpots(_spots.data)
        }
        fetchSpots()
        assignCamId(0)
    }, [])

    return <>
        <Canvas>
            <Suspense fallback={<Loader />}>
                <PresentationCamera />

                {/* <Environment background="only" preset="park"></Environment> */}
                <Environment background="only" files={"rooitou_park_1k.hdr"}></Environment>
                <directionalLight rotation={[30, 50, 15]}></directionalLight>
                {/* <pointLight intensity={0.5} position={[0, 2, 0]}></pointLight> */}
                <ambientLight intensity={.2} color="#DDDDFF"></ambientLight>

                {/* FLOATING LABELS */}
                {camId == 0 ?
                    <>
                        {/* <Html distanceFactor={10} position={[-3.67, 3, -1.2]}>
                            <div className="annotation" onClick={() => assignCamId(2)}>
                                BOTTLES
                            </div>
                        </Html>
                        <Html distanceFactor={10} position={[-3.67, 3.7, -4.5]}>
                            <div className="annotation" onClick={() => assignCamId(7)}>
                                GLASS BOTTLES
                            </div>
                        </Html>
                        <Html distanceFactor={10} position={[3.67, 2.55, -2.5]}>
                            <div className="annotation" onClick={() => assignCamId(3)}>
                                OTHER
                            </div>
                        </Html>
                        <Html distanceFactor={10} position={[3.67, 2.85, 1.65]}>
                            <div className="annotation" onClick={() => assignCamId(4)}>
                                COUNTER
                            </div>
                        </Html> */}
                    </> : <></>
                }

                <RoomBaked></RoomBaked>
                {spots.map((_spot, index) => (
                    <Suspense key={index}>
                        <ProductModel
                            position={camId != 5 ? _spot.data.position : [_spot.data.position[0], _spot.data.position[1] + 0.02, _spot.data.position[2]]}
                            canRotate={camId == 5}
                            labelText={_spot.id}
                            setCurrentSpot={() => setCurrentSpot(_spot)}
                            modelId={_spot.model_id}
                            materialSettings={getMaterialSettings(currentMaterialSettings)}
                        // productModel??
                        />
                    </Suspense>
                ))}
            </Suspense>
        </Canvas>
        <AdminInterface currentSpot={currentSpot} setCurrentSpot={setCurrentSpot} spots={spots} setCurrentMaterialSettings={setCurrentMaterialSettings}></AdminInterface>
    </>
}